<template>
  <div class="BoxCasamento">
    <div class="BoxCasamento_header w-100 d-inline-flex align-items-center justify-content-between p-2"
         :class="`BoxCasamento_header_${propRegistro.status}`">
      <div class="d-inline-flex align-items-center p-0 m-0">
        <b-form-checkbox
          v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL' && propRegistro.acao === 'PUBLICAR_PROCLAMAS'"
          :id="`select_${ _uid }`"
          v-model="localData.registro_id"
          :name="`select_${ _uid }`"
          :value="propRegistro.registro_id"
          @change="changeSelected" />
        <IconSvg v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL'"
                 :icon="statusIcon[propRegistro.status]"
                 class="icon--sm m-0 p-0 mx-2 icons--white" />
        <div class="ml-2">
          {{ getNome() }}
          <br>
          <small>matrícula: </small> {{ propRegistro.registro.matricula | maskMatricula }}
        </div>
      </div>
      <button v-if="propRegistro.status != 'CUMPRIDA' && propRegistro.status != 'CUMPRIDA_MANUAL'"
              class="btn btn-outline-light"
              @click="showPendencias(`BoxPendencia${propIndex}`)">
        Pendências {{ propRegistro.errors ? `(${getQtdErrors(propRegistro.errors.length)})` : '' }}
      </button>
      <div v-if="propRegistro.status === 'CUMPRIDA_MANUAL'"
           class="mr-3">
        <b class="mr-2"> Envio Manual</b>
        <IconSvg icon="touch"
                 class="icon--sm icon-cumprida-manual" />
      </div>
    </div>
    <div class="BoxCasamento_body col-10 d-inline-flex justify-content-between p-2 m-0">
      <div>
        <p class="m-0 p-0 BoxCasamento_body_title">
          Serviço
        </p>
        <p class="m-0 p-0">
          {{ acoes[propRegistro.acao] }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxCasamento_body_title">
          Data de entrada
        </p>
        <p class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.registro.habilitacaoCasamento.data_entrada | date }}
        </p>
      </div>
      <div v-if="false">
        <p class="m-0 p-0 BoxCasamento_body_title">
          Data máxima para cumprir
        </p>
        <p class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.data_max_cumprimento | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxCasamento_body_title">
          Data de cumprimento
        </p>
        <p v-if="propRegistro.data_cumprimento"
           class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.data_cumprimento | date }}
        </p>
        <p v-else
           class="m-0 p-0 BoxCasamento_body_text">
          Não cumprida
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxCasamento_body_title">
          Data da Habilitação
        </p>
        <p class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.registro.habilitacaoCasamento.data_habilitacao | date }}
        </p>
      </div>
      <div>
        <p class="m-0 p-0 BoxCasamento_body_title">
          Data do Ato
        </p>
        <p class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.registro.habilitacaoCasamento.data_casamento | date }}
        </p>
      </div>
      <div v-if="false">
        <p class="m-0 p-0 BoxCasamento_body_title">
          OS
        </p>
        <p class="m-0 p-0 BoxCasamento_body_text">
          {{ propRegistro.registro.ordemServico.map(os => os.ordem_servico_id).join(", ") || "Sem OS" }}
        </p>
      </div>
    </div>
    <div>
      <BoxPendencias :ref="`BoxPendencia${propIndex}`"
                     :prop-errors="propRegistro.errors"
                     :prop-tarefa-id="propRegistro.tarefa_id"
                     :prop-tarefa="propRegistro"
                     :prop-casamento="propRegistro.acao !== 'PUBLICAR_PROCLAMAS' && propRegistro.status !== 'CUMPRIDA' && propRegistro.status !== 'CUMPRIDA_MANUAL'"
                     @openResumo="openResumo(propRegistro, propRegistro.acao)"
                     @reload="reload()" />
    </div>
    <div v-if="!!propRegistro.errors"
         class="row">
      <div class="col">
        <collapse-default :id="`${ _uid }_task_erros_${ propIndex }`"
                          :key="`${ _uid }_task_erros_${ propIndex }`"
                          :collapse-visible="false"
                          :style-default="false">
          <template v-slot:header>
            <span>
              <b class="ml-1 mr-1">Erros</b>
              <small>
                {{ Array.isArray(propRegistro.errors) ? propRegistro.errors.length : qtd_errors }} erros nesse registro
              </small>
            </span>
          </template>

          <template v-slot:content>
            <div class="p-2 row">
              <div class="col-12">
                <ul v-if="Array.isArray(propRegistro.errors)">
                  <li v-for="(error, ind) in propRegistro.errors"
                      :key="`${ _uid }_erros_tarefa_${ ind }`"
                      class="mt-1">
                    {{ error }}
                    <button class="mr-1 btn btn-info btn--xs"
                            @click="openRegister(propRegistro)">
                      Ajustar
                    </button>
                  </li>
                </ul>
                <ul v-else>
                  <li v-if="!!propRegistro.errors.message">
                    {{ propRegistro.errors.message }}
                    <button class="mr-1 btn btn-info btn--xs"
                            @click="openRegister(propRegistro)">
                      Ajustar
                    </button>
                  </li>
                  <li v-if="typeof propRegistro.errors == 'string'">
                    <span v-html="tratarErros(propRegistro.errors)" />
                    <div class="col 12 d-flex justify-content-end">
                      <button class="mr-1 btn btn-info btn--xs ml-auto"
                              @click="openRegister(propRegistro)">
                        Ajustar
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <hr>
            <div class="text-right">
              <button v-if="propRegistro.errors"
                      class="mr-1 mb-2 btn btn-info btn-sm"
                      @click="changeShowErrors(`${ _uid }_task_erros_${ propIndex }`)">
                Fechar
              </button>
            </div>
          </template>
        </collapse-default>
      </div>
    </div>
  </div>
</template>
<script>
  //Components
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"
  import BoxPendencias from '../BoxPendencias'

  //Constants
  import errorsList from '@/constants/errorsCasamento'

  export default {
    name: 'BoxCasamento',
    components: {
      CollapseDefault,
      BoxPendencias
    },
    props: {
      propRegistro: {type: Object, default: () => ({})},
      propSelected: {type: Boolean, default: false},
      propIndex: {type: Number, default: null}
    },
    data () {
      return {
        acoes: {
          "PUBLICAR_PROCLAMAS": "Publicação e-Proclamas",
          'EMISSAO_CERTIDAO_HABILITACAO': "Emitir Habilitação",
          'REGISTRAR_CONVERSAO': "Converter em registro",
          'CELEBRACAO': "Celebração"
        },
        statusIcon: {
          "A_VENCER": "calendarAlert",
          "VENCIDA": "alert",
        },
        localData: {
          registro_id: null
        },
        qtd_errors: 1
      }
    },
    watch: {
      propSelected () {
        if (this.propSelected) this.localData.registro_id = this.propRegistro.registro_id
        else this.localData.registro_id = null
      }
    },
    methods: {
      changeSelected () {
        setTimeout (() => {
          if (this.localData.registro_id) {
            this.$emit('addSelected', this.localData.registro_id)
          } else {
            this.$emit('removeSelected', this.propRegistro.registro_id)
          }
        }, 100)
      },
      getNome () {
        if (this.propRegistro.registro.pessoas.length === 1) return this.propRegistro.registro.pessoas[0].nome
        else return this.propRegistro.registro.pessoas.map(pessoa => pessoa.nome || pessoa.nome_antigo).join('/')
      },
      openRegister (habilitacao) {
        this.$router.push({name: 'editar_habilitacao_casamento', params: {
          id: habilitacao.registro.habilitacaoCasamento.habilitacao_casamento_id
        }})
      },
      openResumo (habilitacao, acao) {
        this.$router.push({name: 'resumo_habilitacao_casamento', params: {
          id: habilitacao.registro.habilitacaoCasamento.habilitacao_casamento_id,
          propImpressao: acao === 'EMISSAO_CERTIDAO_HABILITACAO'
        }})
      },
      changeShowErrors (collapseId) {
        this.$root.$emit('bv::toggle::collapse', collapseId)
      },
      tratarErros (erros) {
        if (!erros) return
        const errors = erros.replace(/\[|]|"|Conteúdo da tag/g,'').split(',')
        let html = ''

        errors.forEach(error => {
          errorsList.forEach(err => {
            error = error.replace(err.name, err.value)
          })

          html += `<li>${ error }</li>`
        })

        this.qtd_errors = errors.length

        return `${html}`
      },
      reload () {
        this.$emit('reload')
      },
      showPendencias (name) {
        this.$refs[name].showBox()
      },
      getQtdErrors (errors) {
        if (Array.isArray(errors)) {
          return errors.length
        } else {
          return '1'
        }
      }
    }
  }
</script>
<style lang="scss">
  .BoxCasamento {
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;

    &_header {
      background: #FFFFFF;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;

      &_CUMPRIDA {
        background: #696969;
      }

      &_CUMPRIDA_MANUAL {
        background: #696969;
      }

      &_VENCIDA {
        background: #8b0000;
      }

      &_A_VENCER {
        background: #7f7e14;
      }
    }

    &_body {
      &_title {
        font-size: 15px;
        font-weight: bold;
        color: #373a3c;
        text-decoration: underline;
      }

      &_text {
        font-size: 15px;
        font-weight: normal;
        text-align: left;
        color: #373a3c;
      }
    }
  }
</style>
